/** Guide visuel binôme : 2 silhouettes pointillées (tête + épaules), sans barre basse. */
const CandidateSilhouetteGuide = ({ className = "" }) => (
  <div
    className={`absolute inset-0 pointer-events-none flex items-end justify-between gap-[2%] px-[2%] pb-[2%] pt-[1%] opacity-50 ${className}`}
    aria-hidden="true"
  >
    {[0, 1].map((slot) => (
      <div key={slot} className="flex h-full w-[46%] items-end justify-center">
        <svg viewBox="0 0 120 180" className="h-full w-full" preserveAspectRatio="xMidYMid meet">
          <ellipse
            cx="60"
            cy="66"
            rx="30"
            ry="42"
            fill="none"
            stroke="rgba(255,255,255,0.92)"
            strokeWidth="3.2"
            strokeDasharray="1.8 10"
            strokeLinecap="round"
          />
          <path
            d="M8 172 C20 140 38 128 60 128 C82 128 100 140 112 172"
            fill="none"
            stroke="rgba(255,255,255,0.92)"
            strokeWidth="3.2"
            strokeDasharray="1.8 10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
    ))}
  </div>
);

export default CandidateSilhouetteGuide;
